import { ContactActionKeys as keys } from './contactActionKeys';
import { ContactActionTypes, IContact } from '.';

export interface IContactState {
  hash: { [index: number]: IContact };
}

const initialState: IContactState = {
  hash: {}
};

export function contactReducer(state: IContactState = initialState, action: ContactActionTypes): IContactState {
  switch (action.type) {
    case keys.FETCH_CONTACTS_FULFILLED:
    case keys.PROCESS_CONTACTS:
      return {
        ...state,
        hash: action.payload.reduce((newHash, contact) => {
          return {
            ...newHash,
            [contact.contactId]: contact
          };
        }, state.hash)
      };
    default:
      return state;
  }
}
